import PayOvertimeRuleByShift from '@/api/hr/pay-overtime-rule-by-shift'
import ShiftWorkingHour from '@/api/hr/shift-working-hour'
import OvertimeItem from '@/api/hr/pay-item-overtime'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  shiftWorkingHours: [],
  overtimeItems: []
}

export const getters = {
  shiftType: state => shiftNo => {
    const shiftWorkingHour = state.shiftWorkingHours.find(sw => sw.id == shiftNo)

    return shiftWorkingHour ? shiftWorkingHour.shift_type : undefined
  },
  dayFrom: state => dayId => {
    const shiftWorkingHour = state.shiftWorkingHours.find(sw => sw.day_id_from == dayId)

    if (shiftWorkingHour === undefined) return ''

    return shiftWorkingHour.day_from
  },
  dayTo: state => dayId => {
    const shiftWorkingHour = state.shiftWorkingHours.find(sw => sw.day_id_to == dayId)

    if (shiftWorkingHour === undefined) return ''

    return shiftWorkingHour.day_to
  }
}

export const mutations = {
  ...baseMutations,

  RECEIVE_EMPLOYEES(state, employees) {
    state.employees = employees
  },

  RECEIVE_SHIFT_WORKING_HOURS(state, shiftWorkingHours) {
    state.shiftWorkingHours = shiftWorkingHours
  },

  RECEIVE_OVERTIME_ITEMS(state, overtimeItems) {
    state.overtimeItems = overtimeItems
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return PayOvertimeRuleByShift.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return PayOvertimeRuleByShift.store(data)
  },

  update(context, { id, ...data }) {
    return PayOvertimeRuleByShift.update(id, data)
  },

  destroy(context, id) {
    return PayOvertimeRuleByShift.destroy(id).then(response => {
      let resource = context.state.resources.find(r => r.record_id == id)

      if (resource) {
        context.state.resources.splice(context.state.resources.indexOf(resource), 1)
      }

      return response
    })
  },

  fetchShiftWorkingHours(context) {
    return ShiftWorkingHour.get().then(response => {
      context.commit('RECEIVE_SHIFT_WORKING_HOURS', response.data)
      return Promise.resolve(response)
    })
  },

  fetchOvertimeItems(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        pay_item_overtime: 'ot_id,ot_name'
      },
      ...attributes
    }

    return OvertimeItem.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params
    }).then(response => {
      context.commit('RECEIVE_OVERTIME_ITEMS', response.data)
      return Promise.resolve(response)
    })
  }
}
